import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=5b4fc65b&scoped=true&lang=pug&"
import script from "./ShowMore.vue?vue&type=script&lang=ts&"
export * from "./ShowMore.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMore.vue?vue&type=style&index=0&id=5b4fc65b&scoped=true&lang=stylus&"
import style1 from "./ShowMore.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fc65b",
  null
  
)

export default component.exports